module.exports = __webpack_public_path__ + "static/media/ember_phoenix.bec7c4da.png";